import customCom from './custom.vue';
const custom = {
    install: (Vue) => {
        //  注册并获取组件，然后再main.js中引用，并Vue.use()挂载
        Vue.component('custom', customCom);
    }
};
export default custom;